export default {"src":"/_next/static/media/visa.c62e67f8.svg","height":504,"width":504,"blurWidth":0,"blurHeight":0};